<!-- 代理等级变更日志 -->
<template>
    <c-dialog ref="performanceRecordDialog" :title="title" width="1200" height="800" enable-flex :button="false">
        <m-search ref="search" @search="search">
            <c-form ref="form" inline>
                <c-form-item type="input" label="终端订单号" name="order_number"></c-form-item>
                <c-form-item type="input" label="下单会员" name="user_info" placeholder="下单会员昵称、手机"></c-form-item>
                <c-form-item type="select" label="下单会员等级" name="user_level" options="USER_LEVEL_AUTH" placeholder="下单会员等级"></c-form-item>
                <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date"></c-form-item>
            </c-form>
        </m-search>
        <c-table ref="performanceRecordTable" height="770">
            <c-table-column label="终端订单号" width="110" name="main_order_number">
                <template v-slot="{data}">
                    <a style="color:blue;" @click="navigateTo(`/order_detail/${data.main_order_number}`)">
                        {{data.main_order_number}}
                    </a>
                </template>
            </c-table-column>
            <c-table-column label="下单会员" width="220">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        <div>
                            <span>{{data.user_manage_mobilephone||'-'}}</span><br/>
                            <span>{{data.nick_name||'-'}}</span>
                        </div>
                    </div>
                </template>
            </c-table-column>
            <c-table-column label="下单会员等级" name="level_name" width="120">
            </c-table-column>
            <c-table-column label="业绩数量" name="settlement_count" width="80"></c-table-column>
            <c-table-column label="业绩金额" name="settlement_money" width="90">
                <template v-slot="{data}">
                    ￥{{ parseFloat(data.settlement_money).toFixed(2) }}
                </template>
            </c-table-column>
            <c-table-column label="创建时间" name="create_date" width="155"></c-table-column>
            <c-table-column label="结算时间" name="settlement_date" width="155">
                <template v-slot="{data}">
                    <span v-if="data.settlement_date">{{data.settlement_date}}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>
            <c-table-column label="备注" name="remark" width="200">
                <template v-slot="{data}">
                    <span v-if="data.remark">{{data.remark}}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
	export default {
		props: {

        },

        data() {
            return {
                title:'代理调整记录',
                serachParams:{}
            }
        },
		
        methods: {
              search(data) {
                  data = Object.assign(data||{},this.serachParams),
                  this.$refs.performanceRecordTable.load({
                      url: '/platform_user/performance/record',
                      data
                  });
              },

              open(params) {
                        this.serachParams = params||{};
                        if (params && params.title){
                            this.title = params.title;
                        }
                        this.$refs.performanceRecordDialog.open();
                        this.$refs.performanceRecordTable.load({
                            url: '/platform_user/performance/record',
                            data:this.serachParams
                        });
              }
        }
	}
</script>